const formatCacheDurationInHours = (hours: number): string =>
  `${hours} ${hours === 1 ? 'hour' : 'hours'}`

const INTRODUCING_BROKERS_CACHE_TTL_HOURS = 24
const introducingBrokersCacheDuration = formatCacheDurationInHours(
  INTRODUCING_BROKERS_CACHE_TTL_HOURS
)

export const INTRODUCING_BROKERS_CACHE_TTL_MS = INTRODUCING_BROKERS_CACHE_TTL_HOURS * 60 * 60 * 1000

export const INTRODUCING_BROKERS_CACHE_MESSAGE = `Introducing Broker options are cached for up to ${introducingBrokersCacheDuration}. Newly created or updated IBs may not appear immediately.`
